import SellerLanding from './SellerLanding.vue'

export default SellerLanding
